import { Pagination } from "./Pagination";

export class LastBalanceV2Entities {
  pagination: Pagination;
  data: LastBalanceV2Data[];
  constructor(pagination: Pagination, data: LastBalanceV2Data[]) {
    this.pagination = pagination;
    this.data = data;
  }
}

export class LastBalanceV2Data {
  code = "";
  name = "";
  lastBalance = 0;
  lastTransaction = "";
  countryCurrency: "IDR" | "MYR" = "IDR";
  picName = "";
  picNumber = "";

  constructor(fields?: Partial<LastBalanceV2Data>) {
    Object.assign(this, fields);
  }
}